import type {ReactElement} from 'react';
import React from 'react';
import {CustomItemControlMt} from '@Components/poster-editor/components/custom-item-control-mt/custom-item-control-mt';
import {CustomItemControlMl} from '@Components/poster-editor/components/custom-item-control-ml/custom-item-control-ml';
import {CustomItemControlMr} from '@Components/poster-editor/components/custom-item-control-mr/custom-item-control-mr';
import {CustomItemControlMb} from '@Components/poster-editor/components/custom-item-control-mb/custom-item-control-mb';
import {CustomSlideshowControlsWrapper} from '@Components/poster-editor/components/custom-slideshow-controls-wrapper/custom-slideshow-controls-wrapper';
import {CustomReplaceControl} from '@Components/poster-editor/components/custom-replace-control/custom-replace-control';
import {CustomEditControl} from '@Components/poster-editor/components/custom-edit-control/custom-edit-control';
import type {CustomItemControlsWrapperProps} from '@Components/poster-editor/components/custom-item-controls/components/custom-item-controls-wrapper/custom-item-controls-wrapper.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetItemsFabricObjectPositionOrDimensionKeysMap} from '@Hooks/poster-editor/useGetItemsFabricObjectPositionOrDimensionKeysMap';

export function SingleItemCustomControls(props: CustomItemControlsWrapperProps): ReactElement | null {
  const activeItemControlProperties = useGetItemsFabricObjectPositionOrDimensionKeysMap(props.pageHashedId);
  const activeItemId = useSingleActivePosterItemId(props.pageHashedId) ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;

  if (activeItemControlProperties?.[activeItemId] === undefined) {
    return null;
  }

  if (Object.keys(activeItemControlProperties).length !== 1) {
    return null;
  }

  const getSingleItemControls = (): ReactElement | null => {
    if (activeItem && !activeItem.fabricObject.lockMovementX) {
      return (
        <>
          <CustomItemControlMt pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />
          <CustomItemControlMl pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />
          <CustomItemControlMr pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />
          <CustomItemControlMb pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />

          {activeItem.isSlideshow() ? <CustomSlideshowControlsWrapper pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} /> : null}
          {activeItem.isImage() ? <CustomReplaceControl pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} /> : null}
          {activeItem.isTableItem() || activeItem.isMenu() ? (
            <CustomEditControl pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />
          ) : null}
        </>
      );
    } else {
      if (activeItem?.fabricObject.lockMovementX) {
        if (activeItem.isSlideshow()) {
          return <CustomSlideshowControlsWrapper pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />;
        }
        if (activeItem.isImage()) {
          return <CustomReplaceControl pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />;
        }
        if (activeItem.isTableItem() || activeItem.isMenu()) {
          return <CustomEditControl pageHashedId={props.pageHashedId} positionProperties={activeItemControlProperties[activeItemId]} />;
        }
      }
      return null;
    }
  };

  return <>{getSingleItemControls()}</>;
}
